import React from 'react';
import { Link } from 'react-router-dom';
import './navitem.css';

const Navitem1 = (props) => {
    return ( <li>
        <Link id='link' className={props.state3} to={props.link}>{props.title}</Link>
    </li> );
}
export default Navitem1;